module.exports = __webpack_public_path__ + "img/gain-de-temps.7c389d31.svg";